import React from 'react';
import Button from '../../artzu-ui/src/Button';
import Modal from '../../artzu-ui/src/Modal';
import { Link } from 'react-router-dom';

const BankingModal = ({ open }) => (
  <Modal open={open}>
    <div className="book-index__banking">
      <div>
        Before you start booking, please enter your bank account information. We need your bank account details to make
        payment to you.
      </div>
      <Link to="/banking-info">
        <Button primary fullWidth label="Okay" onClick={() => {}} />
      </Link>
    </div>
  </Modal>
);

export default BankingModal;



// WEBPACK FOOTER //
// ./src/components/NewBook/BankingModal.js